export default __webpack_public_path__ + "static/cybersource-6b274be1c081f09c91f93144621d3251.png";